import { MessageCircle, Instagram } from "lucide-react";
import { WA_PLAIN, WA_DISPLAY, JAKARTA_AREAS, OTHER_AREAS } from "@/lib/constants";

const NAV_LINKS = [
  { label: "Beranda", href: "#beranda" },
  { label: "Layanan", href: "#layanan" },
  { label: "Keunggulan", href: "#keunggulan" },
  { label: "Area Layanan", href: "#area-layanan" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontak", href: "#kontak" },
];

export default function Footer() {
  const areas = [...JAKARTA_AREAS, ...OTHER_AREAS.filter((a) => a.active)];

  return (
    <footer data-testid="footer" className="border-t border-ink/10 pt-20 pb-28 lg:pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <p className="font-display font-extrabold text-2xl tracking-tight">
              SANJAYA<span className="text-brand-ink">.</span>SERVICE
            </p>
            <p className="mt-4 max-w-sm text-sm text-ink/45 leading-relaxed">
              Service AC, Kulkas, Mesin Cuci & Mesin Laundry
            </p>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-ink/50">
              WhatsApp: 085311491000
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/40 mb-5">Navigasi</p>
            <div className="flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  className="text-sm text-ink/60 hover:text-brand-ink transition-colors duration-300 w-fit"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/40 mb-5">Area Layanan</p>
            <p className="text-sm text-ink/60 leading-relaxed">{areas.map((a) => a.name).join(" · ")}</p>
            <a
              href={WA_PLAIN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 font-display font-bold text-sm text-black hover:bg-ink hover:text-white transition-colors duration-300"
            >
              <MessageCircle size={16} strokeWidth={2.5} />
              Hubungi Kami via WhatsApp
            </a>
            <a
              href="https://www.instagram.com/sanjaya.service/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram Sanjaya Service"
              className="mt-4 inline-flex items-center gap-2 text-sm text-ink/60 hover:text-brand-ink transition-colors duration-300"
            >
              <Instagram size={17} />
              @sanjaya.service
            </a>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-ink/10 flex flex-wrap justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/35">
            © 2026 Sanjaya Service. Semua hak dilindungi.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/35">
            {WA_DISPLAY} — Jakarta & Sekitarnya
          </p>
        </div>
      </div>
    </footer>
  );
}
